import { Component, OnInit } from '@angular/core';
import { LicenseType } from '../../../auth/authorization/license-type.enum';
import { filter } from 'rxjs/operators';
import { Store } from '../../../core/models';
import * as _ from 'lodash';
import { AuthorizationAwareComponent } from '../../../core/authorization-aware-component';
import { AppState } from '../../../app-state';
import { Store as NgrxStore } from '@ngrx/store';
import { SpaceService } from '../../../core/space/space.service';
import { DetailState, selectDetailState } from '../../detail-state';
import { HistoricalStoreStatuses } from '../../../core/identity/constant/store-status-type.enum';
import { WizardRunnerService } from '../../../core/wizard/wizard-runner.service';
import { HistoricalStoresWizard } from './historical-stores-wizard/historical-stores-wizard';
import { RequestMoreStoreInsightWizard } from './request-more-insight-wizard/request-more-store-insight-wizard';
import { StoreVolume } from '../../../core/store/volume/store-volume';
import { HitTrackingService } from 'src/app/core/hit-tracking/hit-tracking.service';
import { USER_TRACKING_ACTION_DESCRIPTIONS, USER_TRACKING_ACTIONS, USER_TRACKING_SOURCES } from 'src/app/core/constants/user-tracking.constants';

@Component({
  standalone: false,
  selector: 'mtn-store-alerts-panel',
  templateUrl: './store-alerts-panel.component.html',
  styleUrls: ['./store-alerts-panel.component.scss']
})
export class StoreAlertsPanelComponent extends AuthorizationAwareComponent implements OnInit {


  alertsCount = 1;
  hasHistoricalStores = false;
  isHistoricalStore = false;
  otherStores: Store[] = [];
  store: Store;
  volumeHistory: StoreVolume[] = [];
  marketName: any;


  private _isOtherStoresInitialized = false;

  constructor(protected ngrxStore: NgrxStore<AppState>,
    private spaceService: SpaceService,
    private wizardRunner: WizardRunnerService,
    private hitTrackingService: HitTrackingService) {
    super(ngrxStore);
  }

  onAuthorizationChange(): void {
  }

  onAuthorizationInit(): void {
    this.loadStore();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  openHistoricalStoresWizard(): void {
    const wizard = new HistoricalStoresWizard();
    wizard.model = {
      otherStores: this.otherStores
    };
    this.wizardRunner.run(wizard);
  }

  openRequestMoreInsightWizard(): void {
    const wizard: any = new RequestMoreStoreInsightWizard();
    wizard.model = {
      store: this.store,
      userProfile: this.currentUser
    };

    const location = this.store?.space?.location;
    const shoppingCenter = this.store?.space?.shoppingCenter;

    const enrichedMetadata = {
      storeId: this.store?.uuid,
      storeName: this.store?.name,
      addressLine1: location?.addressLine1,
      city: location?.city,
      cbsa: this.marketName,
      state: location?.state,
      postalCode: location?.postalCode,
      county: location?.county,
      shoppingCenterName: shoppingCenter?.name,
      landlord: shoppingCenter?.ownerCompany?.name
    };
    const eventName = "Need More Insight?";
    this.hitTrackingService.hitTheUserTracking(
      USER_TRACKING_SOURCES.STORE_NEED_MORE_INSIGHT,
      enrichedMetadata,
      USER_TRACKING_ACTIONS.CLICK_EVENT,
      USER_TRACKING_ACTION_DESCRIPTIONS[USER_TRACKING_ACTIONS.CLICK_EVENT](eventName),
      true
    ).subscribe();

    this.wizardRunner.run(wizard);
  }

  private loadOtherStores(): void {
    if (!this._isOtherStoresInitialized && this.hasLicense(LicenseType.STANDARD)) {
      this._isOtherStoresInitialized = true;
      this.spaceService.findOnesStores(this.store.space.uuid)
        .subscribe((results: Store[]) => {
          if (results.length) {
            const filteredStores = _.reject(results, (result: Store) => result.uuid === this.store.uuid);
            this.otherStores = _.orderBy(filteredStores, (store: Store) => {
              return store.getCurrentStatus().statusDate;
            }, ['desc']);

            this.isHistoricalStore = _.includes(HistoricalStoreStatuses, this.store.getCurrentStatus().getStatusSystemName()) && !!this.otherStores.length;
            this.hasHistoricalStores = !this.isHistoricalStore && !!this.otherStores.length;

            if (this.isHistoricalStore) {
              this.alertsCount++;
            }
            if (this.hasHistoricalStores) {
              this.alertsCount++;
            }
          } else {
            this.otherStores = [];
          }
        });
    }

  }

  private loadStore(): void {
    this.addSubscription(
      selectDetailState(this.ngrxStore)
        .pipe(filter((state: DetailState) => !!state.store))
        .subscribe((state: DetailState) => {
          this.store = state.store;
          const feature = state.marketArea?.getFeature();
          this.marketName = feature?.properties ? feature.properties['name'] : null;
          this.volumeHistory = state.volumeHistory;
          this.loadOtherStores();
        })
    );
  }


}
